<template>
    <vx-card title="Добавление CPA статуса кампаний" id="loader">
        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input v-model="form.name" :danger="!!errors.name" :danger-text="errors.name" autocomplete="off"
                        label="Общее наименование" class="mt-1 w-full required" />
                </div>
            </div>
        </div>

        <div class="vx-row">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input v-model="form.translationRu" :danger="!!errors.translationRu"
                        :danger-text="errors.translationRu" autocomplete="off" label="Наименование (RU)"
                        class="mt-1 w-full required" />
                </div>
            </div>

            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input v-model="form.translationEn" :danger="!!errors.translationEn"
                        :danger-text="errors.translationEn" autocomplete="off" label="Наименование (EN)"
                        class="mt-1 w-full required" />
                </div>
            </div>
        </div>

        <vs-button class="mt-5 mr-2" color="success" @click="save()" type="filled">
            Сохранить
        </vs-button>

        <vs-button class="mt-5" color="primary" @click="cancelEdit()" type="filled">
            Отмена
        </vs-button>
    </vx-card>
</template>


<script>
import vSelect from 'vue-select';
import axios from 'axios';

export default {
    name: 'campaign-cpa-status-create',
    data() {
        return {
            item: undefined,
            form: {
                name: undefined,
                description: undefined,
                statusId: undefined,
                translationRu: undefined,
                translationEn: undefined
            },
            dicts: {
                groups: []
            },
            errors: {
                name: '',
                description: '',
                statusId: '',
                translationRu: '',
                translationEn: ''
            }
        }
    },
    components: {
        'v-select': vSelect
    },
    methods: {
        save() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            const params = {
                id: this.id,
                name: this.form.name,
                description: this.form.description,
                groupId: this.form.groupId,
                translationRu: this.form.translationRu,
                translationEn: this.form.translationEn
            };
            this.$axios({
                method: 'POST',
                url: 'campaign-cpa-statuses',
                params: params,
                errors: this.errors,
                success: (user) => {
                    this.$vs.loading.close("#loader > .con-vs-loading");
                    this.$vs.notify({
                        title: "Успешно обновлено",
                        text: "Статус успешно обновлен",
                        color: "success",
                    });
                    this.$router.push('/campaign-cpa-statuses');
                },
                catch: (err) => {
                    this.$vs.loading.close("#loader > .con-vs-loading");
                    return this.$vs.notify({
                        title: "Внимание!",
                        text: "Ошибка при редактировании статуса!",
                        color: "danger",
                    });
                }
            })
        },
        cancelEdit() {
            this.$router.push('/campaign-cpa-statuses');
        }
    },
    mounted() {
    }
}
</script>

<style>
.select-error>div {
    border: 1px solid rgba(var(--vs-danger), 1) !important;
}
</style>